import { List } from "immutable"
import * as React from "react"
import { hyphen } from "../../components/user_utils"
import * as DrupalModel from '../../custom_models/drupal'
import { ParsedParagraphOpeningHours } from "../../../Shared/api/drupal/types"
import { Container } from "./library/container"
import { Localization, toggleLocationDropdown } from "./Localization/LocalizationLayout"
import { LinkButton } from "./library/button"
import { trackJumboButton } from "./library/tracking"
import { getCookie } from "../../custom_utils/cookies"
import { PREF_BRANCH_COOKIE_TOAST } from "./Localization/LocalizationState"
import { Toast } from "./toast"
import { DrupalDaysOfWeek, GooglePlacesOpeningHours, Period } from "../pages/location_detail_page"
import { ApiResult } from "../../custom_api/api"

interface JumboProps {
  readonly headerTitle: string
  readonly pageTitle?: string
  readonly contents: string | JSX.Element
  readonly headerImageUrl: string
  readonly headerImageAlt: string
  readonly buttonUrl?: string
  readonly buttonTitle?: any
  readonly size: "small" | "large"
  readonly kind?: "default" | "home" | "home-location" | "activity" | "collection",
  readonly email?: string,
  readonly phoneNumber?: string,
  readonly address?: string,
  readonly openingHours?: List<ParsedParagraphOpeningHours>,
  readonly googlePlacesOpeningHours?: ApiResult<GooglePlacesOpeningHours>
  readonly selectedLocationId?: string
  readonly branchLocations?: DrupalModel.Location[]
  readonly selectLocation?: (selectedId: string) => void
}

const renderContents = (contents: string | JSX.Element, htmlElement: JSX.Element, jsxElement: JSX.Element) => {
  return typeof contents == "string" ? (
    <htmlElement.type
      {...htmlElement.props}
      key={htmlElement.key}
      dangerouslySetInnerHTML={{ __html: contents }}
    />
  ) : (
      <jsxElement.type
        key={jsxElement.key}
        {...jsxElement.props}
      >
        {contents}
      </jsxElement.type>
    )
}

export const Jumbotron = {

}

export const Jumbo = (props: JumboProps) => {
  const { size, kind, headerTitle, headerImageUrl, headerImageAlt, pageTitle, googlePlacesOpeningHours } = props
  const { openingHours, phoneNumber, email, address, contents, buttonUrl, buttonTitle } = props
  const { selectedLocationId, branchLocations, selectLocation } = props
  
  const Wrapper = 'header'
  const HeadingLevel = 'h1'
  const pageTitleLabel = headerTitle.replace(/\|/g, '').toLowerCase() == pageTitle?.replace(/\|/g, '').toLowerCase() ? "" : (pageTitle ? hyphen(pageTitle):"")
  const showToast = getCookie(PREF_BRANCH_COOKIE_TOAST)
  const currentDate = new Date()
  const dayOfWeek = currentDate.getDay()

  const loadedGoogleOpeningHours = googlePlacesOpeningHours != undefined && googlePlacesOpeningHours != 'error' && googlePlacesOpeningHours != 'loading' && googlePlacesOpeningHours
  const googleCurrentOpeningHours = loadedGoogleOpeningHours && getGoogleCurrentOpeningHours(googlePlacesOpeningHours, dayOfWeek)
  const drupalOpeningHours = openingHours && getDrupalCurrentOpeningHours(openingHours, dayOfWeek)

  return size == "large" ?
    (kind === 'home' || kind === 'home-location') ? (
        <Wrapper
          className='location-header lh'
          onClick={(e) => {
            const eventTarget:HTMLElement = e.target  as HTMLElement;
            if(eventTarget.closest('.lh__buttoninput') != null) { return; }
            toggleLocationDropdown("true")
          }}
        >
          {showToast === 'true' && <Toast show={showToast} /> }

          <div className="lh__outer">
            <div className='lh__inner'>
              <div className='lh__content'>
                {pageTitleLabel && <span className='lh__label'>{pageTitleLabel}</span>}
                <HeadingLevel className='lh__title'>{hyphen(headerTitle)}</HeadingLevel>
                <div className="lh_meta_container">
                  {(openingHours || phoneNumber || email) && 
                    <ul className='lh__meta'>
                      {address && <li>{address}</li>}
                      {phoneNumber && <li><a className="jumbotron__link" href={"tel:" + phoneNumber}>{phoneNumber}</a></li>}
                      {email && <li><a className="jumbotron__link" href={"mailto:" + email}>{email}</a></li>}
                    </ul>
                  }

                  {loadedGoogleOpeningHours ? <ul className='lh__meta'>
                      <li>Vandaag {googleCurrentOpeningHours !== 'gesloten' && 'open tussen'} {googleCurrentOpeningHours}</li>
                      {googleCurrentOpeningHours !== 'gesloten' && drupalOpeningHours && <li>{drupalOpeningHours.additionalInformation}</li>}
                      <li><a href="#openingstijden">Bekijk alle openingstijden</a></li>
                    </ul>
                    : drupalOpeningHours && 
                    <ul className='lh__meta'>
                      <li>Vandaag {drupalOpeningHours.closed ? 'gesloten' : `open tussen ${drupalOpeningHours.readableTime}`}</li>
                      <li>{drupalOpeningHours.additionalInformation}</li>
                      <li><a href="#openingstijden">Bekijk alle openingstijden</a></li>
                    </ul>
                  }

                  {props.kind === 'home-location' && branchLocations && 
                    <Localization.LocationDropdown
                      selectedLocationId={selectedLocationId}
                      branchLocations={branchLocations}
                      selectLocation={selectLocation}
                    />
                  }
                </div>

                {contents && contents.toString().length > 0 && (
                  renderContents(
                    props.contents,
                    <div className="lh__description" />,
                    <div className="lh__description" />
                  )
                )}

                {headerImageUrl && (
                  <div className="lh__image fit-object hide--mobile-desktop-s">
                    <img src={headerImageUrl} alt={headerImageAlt} />
                  </div>
                )}
              </div>

              {props.kind === 'home' && branchLocations && 
                <Localization.LocationDropdown
                  selectedLocationId={selectedLocationId}
                  branchLocations={branchLocations}
                  selectLocation={selectLocation}
                />
              }    
                
            </div>
        </div>
      </Wrapper>
    ) : (
      <header className={`jumbotron jumbotron--large jumbotron--default${kind === 'collection' ? ' jumbotron--activity' : ''}`}>
        <Container className="jumbotron__inner">
          <div className="jumbotron__content">
            <span className="jumbotron__label">{pageTitleLabel}</span>
            <h1 className="jumbotron__title title--xl">{hyphen(headerTitle)}</h1>

            {(openingHours || phoneNumber || email) && 
              <ul className="jumbotron__list">
                <li className="jumbotron__item">{address ? address : "Geen adres beschikbaar"}</li>
                <li className="jumbotron__item">{phoneNumber ? <a className="jumbotron__link" href={"tel:" + phoneNumber}>{phoneNumber}</a> : ""}</li>
                <li className="jumbotron__item">{email ? <a className="jumbotron__link" href={"mailto:" + email}>{email}</a> : ""}</li>
              </ul>
            }

            {(contents.toString().length > 0 || (buttonUrl && buttonTitle)) && 
              <div className="jumbotron__intro">
                {contents.toString().length > 0 && (
                  renderContents(
                    contents,
                    <div />,
                    <div />
                  )
                )}

                {buttonUrl && buttonTitle && (
                  <LinkButton
                    variant="white"
                    arrow={true}
                    route={buttonUrl}
                    handle={() => trackJumboButton(buttonTitle)}
                    className="jumbotron__clickable"
                  >
                    {buttonTitle}
                  </LinkButton>
                )}
              </div>
            }

            {headerImageUrl && (
              <div className="jumbotron__visual">
                <img src={headerImageUrl} alt={headerImageAlt} />
              </div>
            )}
          </div>
        </Container>
      </header>
      ) : (
      // Default 'small': has title and intro
      <header className="jumbotron jumbotron--small">
        <Container className="jumbotron__inner">
          <div className="jumbotron__content">
            <h1 className="jumbotron__title title--xl">{hyphen(headerTitle)}</h1>
          </div>
          {contents.toString().length > 0 && (
            <div className="jumbotron__intro">
              {renderContents(contents, <p />, <div />)}
            </div>
          )}
        </Container>
      </header>
    )
}


export const getDrupalCurrentOpeningHours = (openingHours: List<ParsedParagraphOpeningHours>, dayOfWeek: number) : { closed: boolean, readableTime: string, additionalInformation: string | null } => {
  const hours: ParsedParagraphOpeningHours | undefined = openingHours.find(h =>  h.field_day === DrupalDaysOfWeek[dayOfWeek])
  
  if (hours === undefined) return null
  return {
    closed: hours.field_closed,
    readableTime: `${hours.field_opening_time} - ${hours.field_closing_time}`,
    additionalInformation: hours.field_additional_information
  }
}

export const getGoogleCurrentOpeningHours = (openingHours: GooglePlacesOpeningHours, dayOfWeek: number): string => {
  const periods = openingHours.periods.filter(p =>  p.open.day === dayOfWeek)
  
  if (periods.length === 0) return 'gesloten'

  let readableTime = ''
  periods.forEach (p => readableTime += `${p.open.readableTime} - ${p.close.readableTime}, ` )
  return readableTime.slice(0, -2)
}
